import styled from "styled-components";
import refreshGrey from "../../assets/Images/refreshGrey.svg"
import refreshBlack from "../../assets/Images/refreshBlack.svg"
import qrRead from "../../assets/Images/Qrread.svg"
import iconTooltip from "../../assets/Images/IconTooltip.svg"

export const Container = styled.div`
  padding: 35px;
  display: flex;
  flex-direction: column;
  align-content: center;
  width: 613px;
  background: #FFFFFF;
  box-shadow: 0px 10px 16px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerTooltip = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: row;
  align-content: center;
  width: 650px;
  background: #FEF4BB;
  border-radius: 8px;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--status-info-1, rgba(253, 218, 36, 1));
  margin-bottom: 20px;
`;

export const Title = styled.h4`
  color: #2C2A29;
  font-family: "CIBFont Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 26px;
  text-align: center;
  letter-spacing: -0.45px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const Description = styled.div`
  max-width: 485px;
  color: #000000;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  letter-spacing: -0.3px;
  padding-bottom: 1em;
  margin: 0 2em;
`;

export const TooltipDescription = styled.div`
  max-width: 600px;
  color: #2C2A29;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  text-align: start;
  letter-spacing: -0.3px;
`;

export const ShortDescription = styled.div`
  max-width: 350px;
  color: #000000;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  text-align: center;
  letter-spacing: -0.3px;
  padding: 1em 0;
`;

export const ContainerButtons = styled.div`
  row-gap: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 285px;
  justify-content: space-between;
`;


export const Button = styled.button`
  color: ${props => props.text || "#2C2A29"};
  background: ${props => props.color || "#FDDA23"};
  border: ${props => props.border || "0"};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.width || "auto"};
  height: 39px;
  border-radius: 100px;
  font-family: "CIBFont Sans";
  font-size: 18px;
  outline: none;
  padding: 9px 41px;
  gap: 8px;
  line-height: 1;
`;

export const ImageRefresh = styled.div`
  background-image:  url(${props => props.enable? refreshBlack : refreshGrey});
  background-repeat: no-repeat;
  background-position: center;
  padding: 15px;
`;

export const QrRead = styled.div`
  background-image:  url(${qrRead});
  background-repeat: no-repeat;
  background-position: center;
  width: 251px;
  height: 250px;
`;

export const QRWrapper = styled.div`
  padding: 30px;
  max-width: 311px;
  width: 100%;
  svg {
    width: 100%;
    height: auto;
  }
`;

export const IconTooltip = styled.div`
  background-image:  url(${iconTooltip});
  background-repeat: no-repeat;
  background-position: center;
  width: 32px;
  height: 32px;
`;

export const TooltipTitle = styled.div`
  color: #2C2A29;
  font-family: "CIBFont Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0px;
  text-align: start;
`;